<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
      <nav-bar></nav-bar>
      <EsimsList />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import EsimsList from '@/components/admin/esimsListPage/EsimsList.vue'
import Auth from '@/services/auth.service.js'


export default {
  components: {
    NavBar,
    EsimsList
  },
  mounted() {
    document.title = 'eSIMS List | ISRASIM'

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>